import axios from '../axios';
// 往来单位分组分组维护列表
export const getBasePartnerGroupPage = data => {
    return axios({
        url: '/api/sys/getBasePartnerGroupPage',
        method: 'post',
        data
    })
};
//往来单位分组列表删除
export const deleteBasePartnerGroups = data => {
  return axios({
      url: '/api/sys/deleteBasePartnerGroups',
      method: 'post',
      data
  })
};
// 往来单位分组保存修改
export const saveBasePartnerGroup = data => {
  // 保存
  if (!data.groupId) {
    return axios({
      url: '/api/sys/saveBasePartnerGroup',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/updateBasePartnerGroup',
      method: 'post',
      data
    })
  }
}
//往来单位分组列表修改
export const updateBasePartnerGroup = data => {
  return axios({
    url: '/api/sys/updateBasePartnerGroup',
    method: 'post',
    data
  })
};
//停用/启用往来单位
export const deactivateBasePartner = data => {
  return axios({
    url: '/api/sys/base/partner/statusBasePartners',
    method: 'post',
    data
  })
};

// 往来单位（客户）列表
export const getBasePartnerPage = data => {
  return axios({
      url: '/api/sys/base/partner/getBasePartnerPage',
      method: 'post',
      data
  })
};
// 获取大供应商列表
export const getBasePartnerOpenList = data => {
  return axios({
      url: '/api/sys/base/partner/getBasePartnerOpenList',
      method: 'post',
      data
  })
};
// 获取大供应商分组列表
export const getBasePartnerCode = data => {
  return axios({
      url: '/api/sys/base/partner/getBasePartnerCode',
      method: 'post',
      data
  })
};
// 往来单位（客户）列表单条
export const getBasePartner = data => {
  return axios({
      url: '/api/sys/getBasePartner',
      method: 'post',
      data
  })
};
// 往来单位（客户）列表删除
export const deleteBasePartners = data => {
  return axios({
      url: '/api/sys/deleteBasePartners',
      method: 'post',
      data
  })
};
// 删除供应商
export const deleteBasePartnerAudits = data => {
  return axios({
      url: '/api/sys/base/partner/deleteBasePartners',
      method: 'post',
      data
  })
};
// 提交供应商
export const submitBasePartner = data => {
  return axios({
      url: '/api/sys/base/partner/submit',
      method: 'post',
      data
  })
};
// 提交承运商
export const submitBaseCarrier = data => {
  return axios({
      url: '/api/sys/submitBaseCarrier',
      method: 'post',
      data
  })
};
// 往来单位（客户）列表审核
export const auditBasePartners = data => {
  return axios({
      url: '/api/sys/auditBasePartners',
      method: 'post',
      data
  })
};
// 往来单位（客户）列表反审核
export const unAuditBasePartners = data => {
  return axios({
      url: '/api/sys/unAuditBasePartners',
      method: 'post',
      data
  })
};
// 往来单位（客户）列表反审核(新)
export const opposeReview = data => {
  return axios({
      url: '/api/sys/base/partner/opposeReview',
      method: 'post',
      data
  })
};
//  往来单位（客户）保存修改
export const saveBasePartner = data => {
  // 保存
  return axios({
    url: '/api/sys/base/partner/saveBasePartner',
    method: 'post',
    data
  })
}
//  往来单位（客户）修改
export const updateBasePartner = data => {
  // 修改
  return axios({
    url: '/api/sys/base/partner/updateBasePartner',
    method: 'post',
    data
  })
}
// 往来单位(审核后修改)
export const updatePartnerMaterial = data => {
  return axios({
    url: '/api/sys/base/partner/updatePartnerMaterial',
    method: 'post',
    data
  })
}
//  修改供应商
export const updateBasePartnerType = data => {
  return axios({
    url: '/api/sys/updateBasePartnerType',
    method: 'post',
    data
  })
}


//导入往来单位
export const uploadPartner = (data) => {
  return axios({
    url: '/api/sys/upload/eq/uploadPartner',
    method: 'post',
    data
  })
}

//导入往来单位
export const downloadExternalPartner = (data) => {
  return axios({
    url: '/api/sys/downloadExternalPartner',
    method: 'post',
    data
  })
}

// 客户信用额度列表
export const getBasePartnerCreditPage = data => {
  return axios({
      url: '/api/sys/base/getBasePartnerCreditPage',
      method: 'post',
      data
  })
};
// 客户信用额度列表(生效)
export const getBasePartnerCreditOnlyUsePage = data => {
  return axios({
      url: '/api/sys/base/getBasePartnerCreditOnlyUsePage',
      method: 'post',
      data
  })
};
// 客户信用额度列表删除
export const deleteBasePartnerCredits = data => {
  return axios({
      url: '/api/sys/base/deleteBasePartnerCredits',
      method: 'post',
      data
  })
};
// 客户信用额度列表保存修改
export const saveBasePartnerCredit = data => {
  // 保存
  return axios({
    url: '/api/sys/base/saveBasePartnerCredit',
    method: 'post',
    data
  })
}
export const saveBasePartnerCreditBatch = data => {// 信用额度批量保存
  return axios({
    url: '/api/sys/base/saveBasePartnerCreditBatch',
    method: 'post',
    data
  })
}
export const updateBasePartnerCredit = data => {// 信用额度修改
  return axios({
    url: '/api/sys/base/updateBasePartnerCredit',
    method: 'post',
    data
  })
}
export const auditBasePartnerCredits = data => {// 信用额度审核.同批次才可
  return axios({
    url: '/api/sys/base/auditBasePartnerCredits',
    method: 'post',
    data
  })
}

// 单位常用联系人列表
export const getBasePartnerContactPage = data => {
  return axios({
      url: '/api/sys/getBasePartnerContactPage',
      method: 'post',
      data
  })
};
// 单位常用联系人列表删除
export const deleteBasePartnerContacts = data => {
  return axios({
      url: '/api/sys/deleteBasePartnerContacts',
      method: 'post',
      data
  })
};
// 单位常用联系人列表保存修改
export const saveBasePartnerContact = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/saveBasePartnerContact',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/updateBasePartnerContact',
      method: 'post',
      data
    })
  }
}

// 单位自有车辆表列表
export const getBasePartnerCarPage = data => {
  return axios({
      url: '/api/sys/getBasePartnerCarPage',
      method: 'post',
      data
  })
};
// 单位自有车辆表删除
export const deleteBasePartnerCars = data => {
  return axios({
      url: '/api/sys/deleteBasePartnerCars',
      method: 'post',
      data
  })
};
// 单位自有车辆表保存修改
export const saveBasePartnerCar = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/saveBasePartnerCar',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/updateBasePartnerCar',
      method: 'post',
      data
    })
  }
}


// 单位运输车辆表列表
export const getBasePartnerWxCarPage = data => {
  return axios({
      url: '/api/sys/getBasePartnerWxCarPage',
      method: 'post',
      data
  })
};
// 单位运输车辆表列表删除
export const deleteBasePartnerWxCars = data => {
  return axios({
      url: '/api/sys/deleteBasePartnerWxCars',
      method: 'post',
      data
  })
};
// 单位运输车辆表列表保存修改
export const saveBasePartnerWxCar = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/saveBasePartnerWxCar',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/updateBasePartnerWxCar',
      method: 'post',
      data
    })
  }
}


// 单位常用地址表列表
export const getBasePartnerAddressPage = data => {
  return axios({
      url: '/api/sys/getBasePartnerAddressPage',
      method: 'post',
      data
  })
};
// 单位常用地址表列表删除
export const deleteBasePartnerAddresss = data => {
  return axios({
      url: '/api/sys/deleteBasePartnerAddresss',
      method: 'post',
      data
  })
};
// 单位常用地址表列表保存修改
export const saveBasePartnerAddress = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/saveBasePartnerAddress',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/updateBasePartnerAddress',
      method: 'post',
      data
    })
  }
}

// 往来单位司机列表
export const getBasePartnerWxDriverPage = data => {
  return axios({
      url: '/api/sys/base/getBasePartnerWxDriverPage',
      method: 'post',
      data
  })
};
// 删除往来单位司机
export const deleteBasePartnerWxDrivers = data => {
  return axios({
      url: '/api/sys/base/deleteBasePartnerWxDrivers',
      method: 'post',
      data
  })
};
// 保存修改往来单位司机
export const saveBasePartnerWxDriver = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/base/saveBasePartnerWxDriver',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/base/updateBasePartnerWxDriver',
      method: 'post',
      data
    })
  }
}

// 客户价格本列表
export const getBasePricePartnerPage = (data) => {
  return axios({
    url: '/api/sys/base/getBasePricePartnerPage',
    method: 'post',
    data
  })
}
// 最新生效的客户价格本
export const inEffectBasePricePartnerPage = (data) => {
  return axios({
    url: '/api/sys/base/inEffectBasePricePartnerPage',
    method: 'post',
    data
  })
}
// 最新生效的项目价格本
export const inEffectBasePriceProjecPage = (data) => {
  return axios({
    url: '/api/sys/base/inEffectBasePriceProjecPage',
    method: 'post',
    data
  })
}
// 批量保存客户价格本
export const batchSaveBasePricePartner = (data) => {
  return axios({
    url: '/api/sys/base/batchSaveBasePricePartner',
    method: 'post',
    data
  })
}
// 批量修改客户价格本
export const updateBasePricePartnerBatch = (data) => {
  return axios({
    url: '/api/sys/base/updateBasePricePartnerBatch',
    method: 'post',
    data
  })
}
// 批量修改_最终价格修改
export const updateBasePricePartnerFinalPriceBatch = (data) => {
  return axios({
    url: '/api/sys/base/updateBasePricePartnerFinalPriceBatch',
    method: 'post',
    data
  })
}
// 客户价格本列表保存
export const saveBasePricePartner = (data) => {
  return axios({
    url: '/api/sys/base/saveBasePricePartner',
    method: 'post',
    data
  })
}
// 客户价格本列表修改
export const updateBasePricePartner = (data) => {
  return axios({
    url: '/api/sys/base/updateBasePricePartner',
    method: 'post',
    data
  })
}
// 客户价格本列表删除
export const deleteBasePricePartners = (data) => {
  return axios({
    url: '/api/sys/base/deleteBasePricePartners',
    method: 'post',
    data
  })
}

//客户销售区域列表
export const getBasePartnerSalesAreaPage = data => {
  return axios({
      url: '/api/sys/base/getBasePartnerSalesAreaPage',
      method: 'post',
      data
  })
};
//客户销售区域列表删除
export const deleteBasePartnerSalesAreas = data => {
  return axios({
      url: '/api/sys/base/deleteBasePartnerSalesAreas',
      method: 'post',
      data
  })
};
//客户销售区域列表停用/启用区域
export const deactivateBasePartnerSalesArea = data => {
  return axios({
      url: '/api/sys/base/deactivateBasePartnerSalesArea',
      method: 'post',
      data
  })
};
//禁用/启用客户项目价格
export const deactivateBasePartnerProject = data => {
  return axios({
      url: '/api/sys/deactivateBasePartnerProject',
      method: 'post',
      data
  })
};
//客户销售区域列表保存修改
export const saveBasePartnerSalesArea = data => {
  if (!data.id) {
    return axios({
        url: '/api/sys/base/saveBasePartnerSalesArea',
        method: 'post',
        data
    })
  } else {
    return axios({
        url: '/api/sys/base/updateBasePartnerSalesArea',
        method: 'post',
        data
    })
  }
};

// 客户生效价格本批量保存
export const batchSaveOfPartner = (data) => {
  return axios({
    url: '/api/sys/base/batchSaveOfPartner',
    method: 'post',
    data
  })
}

// 废钢货主列表
export const getBaseConsignorPage = (data) => {
  return axios({
    url: '/api/sys/base/consignor/getBaseConsignorPage',
    method: 'post',
    data
  })
}
// 保存废钢货主
export const saveBaseConsignor = (data) => {
  return axios({
    url: '/api/sys/base/consignor/saveBaseConsignor',
    method: 'post',
    data
  })
}
// 修改废钢货主
export const updateBaseConsignor = (data) => {
  return axios({
    url: '/api/sys/base/consignor/updateBaseConsignor',
    method: 'post',
    data
  })
}
// 删除废钢货主
export const deleteBaseConsignors = (data) => {
  return axios({
    url: '/api/sys/base/consignor/deleteBaseConsignors',
    method: 'post',
    data
  })
}
// 禁用/启用废钢货主
export const forbidBaseConsignors = (data) => {
  return axios({
    url: '/api/sys/base/consignor/forbidBaseConsignors',
    method: 'post',
    data
  })
}
// 确认废钢货主
export const auditBaseConsignors = (data) => {
  return axios({
    url: '/api/sys/base/consignor/auditBaseConsignors',
    method: 'post',
    data
  })
}
// 反确认废钢货主
export const unauditBaseConsignors = (data) => {
  return axios({
    url: '/api/sys/base/consignor/unauditBaseConsignors',
    method: 'post',
    data
  })
}
// 废钢货主银行列表
export const getBasePartnerBankPage = (data) => {
  return axios({
    url: '/api/sys/base/partner/bank/getBasePartnerBankPage',
    method: 'post',
    data
  })
}
// 保存废钢货主银行
export const saveBaseConsignorBank = (data) => {
  return axios({
    url: '/api/sys/base/partner/bank/saveBasePartnerBank',
    method: 'post',
    data
  })
}
// 修改废钢货主银行
export const updateBasePartnerBank = (data) => {
  return axios({
    url: '/api/sys/base/partner/bank/updateBasePartnerBank',
    method: 'post',
    data
  })
}
//删除废钢货主银行
export const deleteBasePartnerBanks = (data) => {
  return axios({
    url: '/api/sys/base/partner/bank/deleteBasePartnerBanks',
    method: 'post',
    data
  })
}

//  单位承运商保存
export const sysSaveBasePartnerCarrier = data => {
  return axios({
    url: '/api/sys/saveBasePartnerCarrier',
    method: 'post',
    data
  })
}
//  客户余额表列表
export const getBasePartnerBalancePage = data => {
  return axios({
    url: '/api/sys/base/partner/balance/getBasePartnerBalancePage',
    method: 'post',
    data
  })
}
//  客户余额表充值
export const addBalance = data => {
  return axios({
    url: '/api/sys/base/partner/balance/addBalance',
    method: 'post',
    data
  })
}
//  客户余额变动日志列表
export const getBasePartnerBalanceLogPage = data => {
  return axios({
    url: '/api/sys/base/partner/balance/log/getBasePartnerBalanceLogPage',
    method: 'post',
    data
  })
}

// 客户信用额度列表
export const getBasePartnerCreditLimitPage = data => {
  return axios({
    url: '/api/sys/base/partner/credit/limit/getBasePartnerCreditLimitPage',
    method: 'post',
    data
  })
}

// 充值客户信用额度（需审批）
export const rechargeBasePartnerCreditLimit = data => {
  return axios({
    url: '/api/sys/base/partner/credit/limit/rechargeBasePartnerCreditLimit',
    method: 'post',
    data
  })
}

// 客户信用额度操作记录列表
export const getBasePartnerCreditLimitLogPage = data => {
  return axios({
    url: '/api/sys/base/partner/credit/limit/log/getBasePartnerCreditLimitLogPage',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/Customer.js